import { Box, Chip } from '@dtx-company/design-system/src'
import { PlanPurchasePlanIntervalPicker } from '@app/plans/src/purchase/PlanPurchasePlanIntervalPicker/PlanPurchasePlanIntervalPicker'
import { useBuyPlanPageContext } from '../../context/useBuyPlanPageContext'
import { variants } from '@dtx-company/design-system/src/components/Typography/Typography.overrides'
import React from 'react'

export function BuyPlanPagePlanPicker(): JSX.Element {
  const { document } = useBuyPlanPageContext()
  const { data } = document
  const planLabel = data.plan_label ?? ''
  const currencyLabel = data.currency_abbreviation

  return (
    <Box
      sx={theme => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        '& .MuiFormControl-root.MuiTextField-root .MuiInputBase-root.MuiFilledInput-root': {
          border: 'none',
          height: theme.spacing(6),
          mt: -1 //can't override the Stack used in <Select/>
        },
        '& .MuiFormControl-root.MuiTextField-root .MuiInputBase-root .MuiInputBase-input': {
          py: 0,
          pl: 0
        },
        '& .MuiFormControl-root.MuiTextField-root .MuiInputBase-root.Mui-focused': theme => ({
          outline: 'none',
          borderBottom: `2px solid ${theme.palette.shades.primary.active}`
        })
      })}
    >
      <PlanPurchasePlanIntervalPicker
        heapId="BuyPlanPage_PlanPicker"
        label={planLabel}
        size="small"
        optionLabels={{
          yearly: data.billed_annually_label || '',
          monthly: data.billed_monthly_label || ''
        }}
        fullWidth
        InputLabelProps={{
          sx: theme => ({ ...variants.subtitleSmall, color: theme.palette.primary.main })
        }}
        InputProps={{
          sx: theme => ({ ...variants.subtitleSmall, color: theme.palette.onSurface.secondary })
        }}
        labelAbove
      />
      {currencyLabel !== undefined && <Chip label={currencyLabel} variant="outlined" />}
    </Box>
  )
}
